export const TYPE_IMAGE = 1
export const TYPE_FILE = 2
export const TYPE_ARCHIVE = 3
export const TYPE_OTHER = 4

export default {
    [TYPE_IMAGE]: {
        name: 'Afbeelding',
        icon: 'image',
    },
    [TYPE_FILE]: {
        name: 'Document',
        icon: 'description',
    },
    [TYPE_ARCHIVE]: {
        name: 'Archief',
        icon: 'inventory_2',
    },
    [TYPE_OTHER]: {
        name: 'Bestand',
        icon: 'insert_drive_file',
    },
}
